import { Page as PageType } from "../types";
import SectionList from "./SectionList";

interface PageProps {
  page: PageType;
}

const Page: React.FC<PageProps> = ({ page }) => {
  return (
    <div className="page">
      <header>
        <h2>{page.label}</h2>
        <p>{page.description}</p>
      </header>
      <SectionList sections={page.sections} layout={page.layout} />
    </div>
  );
};

export default Page;
